import { OfferState } from './-types'
import constants from './-constants'

const { SET_OFFER_DETAILS } = constants.mutation
export default {
  [SET_OFFER_DETAILS](state: OfferState, data: { offer: any, sections: any[] }) {
    state.offer = data.offer;
    state.sections = data.sections || [];
  }
}
